export default __webpack_public_path__ + "static/media/quotes.6df68f55.svg";